<template>
  <div>
    <div v-if="!isMobileAppWebView" id="login">
      <div v-if="stage == 1">
        <v-form class="login-form">
          <v-text-field ref="username" v-model="username" :error="error" :label="`${$t('login.username')}`"
                        required></v-text-field>
          <v-text-field ref="password" v-model="password" :error="error" :label="`${$t('login.password')}`"
                        required
                        type="password"></v-text-field>
          <v-switch v-model="keepLogged" :label="`${$t('login.keep-logged')}`" class="keep-me-logged"></v-switch>
          <v-btn :class="{loading: loading}" :disabled="!username || !password || loading" color="teal" large round
                 style="color: #fff" @click="login">
            {{ $t('login.login') }}
          </v-btn>
          <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
        </v-form>
      </div>

      <div v-if="stage == 2">
        <v-form class="login-form">
          <v-text-field ref="sms_code" v-model="sms_code" :error="error" label="Kod sms"
                        required></v-text-field>

          <v-btn :class="{loading: loading}" :disabled="!sms_code || loading" color="teal" large round
                 style="color: #fff" @click="login">
            {{ $t('login.login') }}
          </v-btn>
          <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
        </v-form>
      </div>
    </div>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script>
import Settings from "@/plugins/Settings"
import langs from "@/plugins/langs"

export default {
  data() {
    return {
      stage: 1,
      username: "",
      password: "",
      sms_code: "",
      keepLogged: false,
      loading: false,
      error: false,
      Settings
    }
  },
  computed: {
    isMobileAppWebView() {
      return this.$store.state.isMobileAppWebView
    },
  },
  created() {
    this.initLang()
    window.addEventListener('keydown', this.keydownHandler)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keydownHandler)
  },
  methods: {
    getLoginData(){
      let data = {
        username : this.username,
        password : this.password,
        keepLogged : this.keepLogged
      }

      if(this.sms_code != '' && !!this.sms_code){
        data['sms_code'] = this.sms_code
      }

      return data
    },
    login() {
      this.loading = true
      this.$store.dispatch("authPassword", this.getLoginData()).then((data) => {
        this.loading = false

        if(data && data.code && data.code == 'sended'){
          this.stage = 2
          return
        }

        this.$store.dispatch("load")
        this.$store.dispatch("whoami").then(() => {
          this.$store.commit("setSnack", {
            message: this.$t("login.success-message"),
            color: "success"
          })
          window.removeEventListener('keydown', this.keydownHandler)
          this.$router.push({
            name: Settings.getEntrypoint()
          })

          if (this.$websocket.isEnabled()) {
            this.$websocket.createConnection()
          }
        })
      }).catch(() => {
        this.loading = false
        this.error = true
        this.$store.commit("setSnack", {
          message: this.$t("login.fail-message"),
          color: "error"
        })
      })
    },
    initLang() {
      let lang = this.$route.query.lang
      if (langs.getSupportedLangs().includes(lang)) {
        this.$store.commit("changeLanguage", lang)
      }
    },
    keydownHandler(e) {
      if (e.key == 'Enter' && this.username && this.password && !this.loading && !this.$store.getters.isAuthenticated) {
        if (window.location.href.includes('/login')) {
          this.login()
        }
      }
    }
  },
}
</script>

<style scoped>
.v-alert {
  padding: 10px;
  margin: 15px 0;
  max-width: 500px;
}

.login-form {
  max-width: 400px;
  padding: 30px;
}
</style>
